module.exports = __webpack_public_path__ + "static/media/ios-color-palette.b2ce1b89.svg";